import React, { FC, MouseEvent } from 'react'
import Image from 'next/image'
import { ChoiseChip } from '@shared/ui/molecules'
import { ICON_TCP } from '@shared/config'
import { DenominationCategoryType } from '../model/denomination.types'

interface DenominationCategoryProps {
  isSelected: boolean
  category: DenominationCategoryType
  onClick: (e: MouseEvent<HTMLElement>, category: DenominationCategoryType) => void
}

const DenominationCategory: FC<DenominationCategoryProps> = ({ isSelected, category, onClick }) => {
  const handleCategoryClick = (e: MouseEvent<HTMLElement>) => onClick(e, category)

  return (
    <ChoiseChip
      size={{ desktop: 'l', mobile: 'm' }}
      variant={isSelected ? 'selected' : 'default'}
      icon={category.icon && <Image src={`${ICON_TCP}${category.icon}`} alt="category icon" width={24} height={24} />}
      onClick={handleCategoryClick}
    >
      {category.label}
    </ChoiseChip>
  )
}

export default DenominationCategory
